/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import MikeButton from "../mike-button/MikeButton"
import mikeSharedTheme, { mikePalette } from "../../styles/mikeSharedTheme"
import { useAppDispatch } from "../../store/store";
import { drawingEnabled, showNewLegendLayer } from "../../reducers/legend";
import { useTypedSelector } from "../../reducers";
import MikeVisualizerLib from "../../MikeVisualizer/lib/MikeVisualizer";
import { onDrawnDataUpdated } from "../../MikeVisualizer/lib/MikeVisualizerEvents";
import { useEffect } from "react";
import { Feature, FeatureCollection, Point } from 'geojson';
import { coordinatesSet } from "../../reducers/measures";
import { NEW_MEASURES_ID } from "../../model/layerGroups";
import { makeDefaultVectorStyle, MAP_COLORS } from "../ViewerLegend/utils";

const containerStyle = css`       
  position: absolute;
  top: 116px;
  right: 16px;
  z-index:80;
  background-color: ${mikePalette.background.paper};
  
`;

const bigButtonContainerStyle = css` 
  padding: ${mikeSharedTheme.spacing(1)};
`;

const bigButtonStyle = css`       
  min-width: 300px;  
  max-width: 300px;  
  height: 80px;
  padding: ${mikeSharedTheme.spacing(1)};
`;

interface IProps {
  onOpenMeasureDialog: () => void;
  disabled: boolean;
}

const MeasureButtonPanel = (props: IProps) => {
  const { onOpenMeasureDialog, disabled } = props;
  const drawing = useTypedSelector((state) => state.legend.drawing);
  const dispatch = useAppDispatch(); 

  useEffect(
    () => {
      const drawUpdateCallback = async (updatedFC: FeatureCollection<any, any>) => {
        if (drawing && updatedFC.features.length > 0) {
          const {update2DData, clearDrawnVectorLayerData} = MikeVisualizerLib;
          await update2DData(updatedFC, NEW_MEASURES_ID, undefined, undefined, 1, makeDefaultVectorStyle(MAP_COLORS.LILAC));
          dispatch(showNewLegendLayer(true));    
          const feature = updatedFC.features[0] as Feature<Point>;
          const geometry = feature.geometry
          dispatch(coordinatesSet(geometry.coordinates));
          clearDrawnVectorLayerData();
        }
      };

      const unsubscribers = Array<any>();
      const unsubscribeOnDrawnDataUpdated = onDrawnDataUpdated(drawUpdateCallback);
      unsubscribers.push(unsubscribeOnDrawnDataUpdated);

      return () => {
        unsubscribers.forEach((unsubscribe) => unsubscribe());
      };
    },
    [dispatch, drawing],
  );

  const enableDrawMeasure = () => {
    dispatch(drawingEnabled(true));    
  }

  const openMeasureDialog = () => {    
    onOpenMeasureDialog();
  }

  return (
    <div css={containerStyle}>
      <div css={bigButtonContainerStyle}>
        <MikeButton disabled={disabled} css={bigButtonStyle} variant="contained" onClick={enableDrawMeasure}>
          Neue Maßnahme über Punkt-Setzen starten
        </MikeButton>
      </div>

      <div css={bigButtonContainerStyle}>
        <MikeButton disabled={disabled} css={bigButtonStyle} variant="contained" onClick={openMeasureDialog}>
          Neue Maßnahme über Koordinaten im Eingabe-Dialog starten
        </MikeButton>
      </div>
    </div>
  )
}

export default MeasureButtonPanel